import React from "react";
import { api } from "@/lib/config";

export default function Overview() {
  const [stats, setStats] = React.useState({ quotes: 0, bookings: 0, contacts: 0, estimates: 0 });
  React.useEffect(() => {
    (async () => {
      const [q, b, c, e] = await Promise.all([
        api.get("/admin/quotes"), api.get("/admin/bookings"),
        api.get("/admin/contacts"), api.get("/admin/estimates"),
      ]);
      setStats({
        quotes: q.data.items.length, bookings: b.data.items.length,
        contacts: c.data.items.length, estimates: e.data.items.length,
      });
    })().catch(() => {});
  }, []);
  const cards = [
    { key: "quotes", label: "Quote requests", value: stats.quotes },
    { key: "bookings", label: "Bookings", value: stats.bookings },
    { key: "contacts", label: "Contact messages", value: stats.contacts },
    { key: "estimates", label: "Estimates", value: stats.estimates },
  ];
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="admin-overview">
      {cards.map((c) => (
        <div key={c.key} data-testid={`stat-${c.key}`} className="rounded-2xl border border-black/10 bg-white p-6">
          <div className="eyebrow text-[color:var(--brand-wood)]">{c.label}</div>
          <div className="mt-4 font-display text-4xl">{c.value}</div>
        </div>
      ))}
    </div>
  );
}
